import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { CategoryRestrictionsProfileConfiguration } from '@rocksoft/settings-sdk';

export type CategoryRestrictionProfilePresetConfigurationState = EntityState<CategoryRestrictionsProfileConfiguration>;

export function selectId(configuration: CategoryRestrictionsProfileConfiguration): string {
  return `${configuration.restrictionsProfilePresetId}-${configuration.categoryType}-${configuration.categoryId}`;
}

export const adapter: EntityAdapter<CategoryRestrictionsProfileConfiguration> =
  createEntityAdapter<CategoryRestrictionsProfileConfiguration>({
    selectId,
  });

export const initialState: CategoryRestrictionProfilePresetConfigurationState = adapter.getInitialState();

/**
 * Partial state interface for components that use category restriction profile preset configuration store
 * Includes both categoryRestrictionProfilePresetConfiguration and restrictionProfiles feature states
 */
export interface CategoryRestrictionProfilePresetConfigurationPartialState {
  categoryRestrictionProfilePresetConfiguration: CategoryRestrictionProfilePresetConfigurationState;
  restrictionProfiles: import('../apple-profile-preset/apple-profile-preset.state').AppleProfilePresetState;
}
